import React from 'react';
import {_GPY,__GPYPost,__GPYGetUIStates} from '../env.js'
import Version from '../Version.js'

class LoginForm extends React.Component  {

		constructor(props) {
		 super(props);
		 this.state = {
						email: process.env.REACT_APP_defaultUser,
						_email: process.env.REACT_APP_defaultUser !== "",
						password: process.env.REACT_APP_defaultPass,
						_password: process.env.REACT_APP_defaultPass !== "",
						autologin: process.env.REACT_APP_autoLogin === "true",
						_fail: false,
					};
		 }

		 componentDidMount(){
			 	if(this.state.autologin) {
					this.doLogin();
				}
		 }

		 doLogin() {
			 this.setState({_fail:false});

				 __GPYPost("doLogin",this.state,(res) => {
					 	 console.log(res.Result.state) ;
						 if(res.Result.state === "OK"){
							 	 __GPYGetUIStates();
							 	 _GPY.userIsLoggedIn = true;
						 } else {
							 	this.loginFail();
						 }
				 }, () => {
					 	this.loginFail();
				 }
			 );
		 }

		 loginFail(){
			 this.setState({_fail:true});
			 this.interval = setInterval(() => this.closeFail(), (5000));
		 }

		 closeFail() {
			  this.setState({_fail:false});
				clearInterval(this.interval);
		 }

		 setCurrentForm(f) {
			 console.log(f);
		     this.props.login.setCurrentForm(f);
		 }

		 validateEmail(e) {
				this.setState({email: e.target.value, _email : _GPY.isEmpty(e.target.value)});
		 }

		 handleKeyPress(event) {
		     if (event.key === 'Enter') {
		       this.doLogin();
		     }
		   }


		 validatePassword (e) {
				this.setState({password: e.target.value,_password : _GPY.isEmpty(e.target.value)});
		  }

		 render () {
				    return (
						<div>
					   <div  className="jumbotron">
						 <div className="row">
						 		<div className="col"><h1 className="display-4">{_GPY.i18n.get('login_form_headLine')}</h1></div>
						 		<div className="col text-right"><img style={{maxWidth : '200px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid mx-auto" alt="Guppyi Logo"/></div>
						 </div>

							<p className="lead">{_GPY.i18n.get('login_form_subHeadLine')}</p>
							<small><Version/></small>

						  <hr className="my-4"/>
								  <div className="	form-group">
								    <label htmlFor="inputEmail">{_GPY.i18n.get('login_form_input_email_title')}</label>
						 		    <input name="login_email" onChange={this.validateEmail.bind(this)} value={this.state.email}  type="email" className="form-control" id="inputEmail" aria-describedby="emailHelp" placeholder={_GPY.i18n.get('login_form_input_email_placeholder')}/>
						 		 </div>
								 <div className="form-group">
						  		    <label htmlFor="inputPassword">{_GPY.i18n.get('login_form_input_password_title')}</label>
						  		    <input name="login_password" onKeyPress={this.handleKeyPress.bind(this)} onChange={this.validatePassword.bind(this)} value={this.state.password} type="password" className="form-control activeInput" id="inputPassword" placeholder={_GPY.i18n.get('login_form_input_password_placeholder')}/>
						 		 </div>

						 		 <div className="row">
							 		<div className="col">
						 		 		<button className="btn btn-light btn-lg" onClick={this.setCurrentForm.bind(this,"LoginRegisterForm")} >{_GPY.i18n.get('login_form_button_register')}</button>
						 		 	</div>

						 		 	<div className="col">
						 		 		<div className="float-right">
										{this.state._email && this.state._password?
												<button onClick={this.doLogin.bind(this)} className="btn btn-primary btn-lg">{_GPY.i18n.get('login_form_button_login')}</button>
									  :
											<button className="btn btn-primary btn-lg disabled">{_GPY.i18n.get('login_form_button_login')}</button>
								   	}
						 		 		 </div>
						 		 	</div>
						 		  </div>

								  <div className="row pt-3 ">
									<div className="col-8">
										{this.state._fail? <div className="alert alert-danger" role="alert">{_GPY.i18n.get('login_form_login_fail')}</div>:""}
									</div>

							 		<div className="col-12"><button className="btn btn-link p-0" onClick={this.setCurrentForm.bind(this,"LoginLostPasswordForm")}>{_GPY.i18n.get('login_form_input_link_lostPassword')}</button></div>
						 		  </div>

									<div className="col-12 p-0 pt-1"><hr/></div>
									<div className="col-12 p-0 pt-1">{_GPY.i18n.get('login_form_telegram_description')}</div>

									<div className="col-12 p-0 pt-1">
										<div className="row">
											<div className="col-6"><a target="_new" href="https://telegram.org/">https://telegram.org</a></div>
											<div className="col-6"><a target="_new" href="https://t.me/guppyi_scorebard">{_GPY.i18n.get('login_form_telegram_join')}</a></div>
										</div>
									</div>
						</div>


						</div>
			  	)
		  }
}
export default LoginForm;
